<template>
  <header class="app-top-header">
    <div class="container topbar-inner">
      <router-link to="/" class="logo">
        <img src="../assets/app-logo.svg" alt="Nomade Digital" class="logo-img" />
        <span class="logo-text">Nomade Digital</span>
      </router-link>
      <nav class="nav">
        <router-link to="/discover" class="nav-item" :class="{ 'nav-item-active': discoverNavActive }">{{ $t('nav.discover') }}</router-link>
        <router-link to="/app" class="app-btn">
          <span class="app-btn-dot" aria-hidden="true"></span>
          {{ $t('nav.app') }}
        </router-link>
      </nav>
      <div class="right-actions">
      <LanguageSwitcher />
      <div v-if="showUserEntry" class="user-actions">
        <button
          v-if="showLogoutButton"
          type="button"
          class="logout-btn"
          @click="$emit('logout')"
        >
          {{ $t('nav.logout') }}
        </button>
        <router-link
          v-else
          :to="accountRoute"
          class="avatar"
          :aria-label="accountAriaLabel"
        >👤</router-link>
      </div>
      </div>
    </div>
  </header>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  name: "AppTopHeader",
  components: { LanguageSwitcher },
  props: {
    /** When true (e.g. city page), Discover is shown as active even off /discover */
    highlightDiscover: {
      type: Boolean,
      default: false,
    },
    /** Set false on account-only layouts that use their own actions */
    showUserEntry: {
      type: Boolean,
      default: true,
    },
    /** Minha conta: mesmo header da home, com Sair em vez do atalho de login */
    showLogoutButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["logout"],
  data() {
    return { authTick: 0 };
  },
  computed: {
    discoverNavActive() {
      if (this.highlightDiscover) return true;
      return this.$route.path === "/discover";
    },
    isLoggedIn() {
      this.authTick;
      return !!localStorage.getItem("token");
    },
    accountRoute() {
      return this.isLoggedIn ? "/my-account" : "/login";
    },
    accountAriaLabel() {
      return this.isLoggedIn ? this.$t('nav.account') : this.$t('nav.login');
    },
  },
  watch: {
    $route() {
      this.authTick += 1;
    },
  },
  mounted() {
    window.addEventListener("focus", this.bumpAuth);
  },
  beforeUnmount() {
    window.removeEventListener("focus", this.bumpAuth);
  },
  methods: {
    bumpAuth() {
      this.authTick += 1;
    },
  },
};
</script>

<style scoped>
.app-top-header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  background: rgba(10, 20, 38, 0.82);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}
.container {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 20px;
}
.topbar-inner {
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #7eb3ff;
  font-weight: 800;
  font-size: 19px;
  text-decoration: none;
  letter-spacing: -0.02em;
}
.logo-img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: block;
}
.logo-text {
  line-height: 1;
}
.nav {
  display: flex;
  gap: 20px;
  align-items: center;
}
.nav-item {
  color: #94adc8;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}
.nav-item-active {
  color: #7eb3ff;
  border-bottom: 2px solid #7eb3ff;
}
.right-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.user-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.avatar {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1e3352;
  text-decoration: none;
}
.logout-btn {
  border: none;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  background: #ef4444;
  color: #fff;
}
.logout-btn:hover {
  background: #dc2626;
}
.app-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: linear-gradient(135deg, #004ac6, #0284c7);
  color: #fff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
  border-radius: 999px;
  padding: 7px 16px;
  transition: opacity 0.2s, transform 0.15s;
  white-space: nowrap;
}
.app-btn:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}
.app-btn-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #86efac;
  box-shadow: 0 0 0 2px rgba(134, 239, 172, 0.4);
  animation: pulse-dot 2s infinite;
  flex-shrink: 0;
}
@keyframes pulse-dot {
  0%, 100% { box-shadow: 0 0 0 2px rgba(134, 239, 172, 0.4); }
  50%       { box-shadow: 0 0 0 5px rgba(134, 239, 172, 0.15); }
}
@media (max-width: 640px) {
  .nav {
    display: none;
  }
}
</style>
